import { rem } from "polished";
import styled from "styled-components";

import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";
import StyledButtonContainer from "@/components/editor/themes/nolan/shared/cta-button";
import { ColorLabels } from "@/components/editor/utils/colors";

export const BlockBackground = styled.div`
  background-color: ${({ theme }) => theme.colors[ColorLabels.PRIMARY]};
`;

const Wrapper = withViewportStyle(StyledButtonContainer)`
  display: grid;
  grid-auto-rows: max-content;
  grid-gap: ${rem(16)};
  padding: ${rem(120)} 0;
  max-width: ${rem(1016)};
  margin: 0 auto;

  ${(props) => props.$viewport.tablet`
    padding: ${rem(80)} ${rem(24)};
  `}
  
  ${(props) => props.$viewport.mobile`
    padding: ${rem(40)} ${rem(16)};
  `}

  .nolan .ck-content h2,
  .nolan .ck-content h3,
  .nolan .ck-content h4,
  .nolan .ck-content h5,
  .nolan .ck-content li,
  .nolan .ck-content p {
    color: ${({ theme }) =>
      theme.colors[ColorLabels.SECONDARY_FONT]} !important;
    margin: 0 auto;
  }

  .button-primitive {
    margin: 0 auto;
    width: max-content;
    background: ${({ theme }) => theme.colors[ColorLabels.BACKGROUND]};
    color: ${({ theme }) => theme.colors[ColorLabels.PRIMARY]};
  }
`;

export { Wrapper };
